import { render } from "./PartnerNoticeManageView.vue?vue&type=template&id=5d860e47&scoped=true"
import script from "./PartnerNoticeManageView.vue?vue&type=script&lang=js"
export * from "./PartnerNoticeManageView.vue?vue&type=script&lang=js"

import "./PartnerNoticeManageView.vue?vue&type=style&index=0&id=5d860e47&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d860e47"]])

export default __exports__